// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: preset.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

import { AlgoServiceCommandList } from './algo'
import { OrderSide, orderSideFromJSON, orderSideToJSON } from './common/trading'
import { TradeVenue, tradeVenueFromJSON, tradeVenueToJSON } from './common/types'
import { OrderExecutionCommandList } from './execution'

export const protobufPackage = 'preset'

export enum PresetKind {
  PRESET_KIND_UNSPECIFIED = 0,
  /** PRESET_KIND_MANUAL - commands only */
  PRESET_KIND_MANUAL = 1,
  /** PRESET_KIND_ALGO - algo_commands only */
  PRESET_KIND_ALGO = 2,
  /** PRESET_KIND_MIXED - both */
  PRESET_KIND_MIXED = 3,
  UNRECOGNIZED = -1,
}

export function presetKindFromJSON(object: any): PresetKind {
  switch (object) {
    case 0:
    case 'PRESET_KIND_UNSPECIFIED':
      return PresetKind.PRESET_KIND_UNSPECIFIED
    case 1:
    case 'PRESET_KIND_MANUAL':
      return PresetKind.PRESET_KIND_MANUAL
    case 2:
    case 'PRESET_KIND_ALGO':
      return PresetKind.PRESET_KIND_ALGO
    case 3:
    case 'PRESET_KIND_MIXED':
      return PresetKind.PRESET_KIND_MIXED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return PresetKind.UNRECOGNIZED
  }
}

export function presetKindToJSON(object: PresetKind): string {
  switch (object) {
    case PresetKind.PRESET_KIND_UNSPECIFIED:
      return 'PRESET_KIND_UNSPECIFIED'
    case PresetKind.PRESET_KIND_MANUAL:
      return 'PRESET_KIND_MANUAL'
    case PresetKind.PRESET_KIND_ALGO:
      return 'PRESET_KIND_ALGO'
    case PresetKind.PRESET_KIND_MIXED:
      return 'PRESET_KIND_MIXED'
    case PresetKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * Stored payload — what we serialize into the DDB `payload` blob.
 *
 * Account-bound fields (NewOrderParams.account_id, StartAlgo.account_id) are
 * the binding a preset executes against: ExecutePreset runs each leg on the
 * account stored here unless the request supplies an account_id to override
 * every leg with.
 */
export interface PresetPayload {
  commands: OrderExecutionCommandList | undefined
  algoCommands: AlgoServiceCommandList | undefined
}

/** Full preset record (returned by Create/Update and Get). */
export interface Preset {
  /** 8-char hashid, immutable */
  presetId: string
  /** unique per user across non-deleted rows */
  name: string
  /** derived from payload at write time */
  kind: PresetKind
  /** epoch ms */
  createdAt: string
  /** epoch ms */
  updatedAt: string
  /** soft-delete tombstone */
  deleted: boolean
  payload: PresetPayload | undefined
}

/**
 * Lightweight projection used by ListPresets so the frontend can render the
 * list without paying for every payload.
 */
export interface PresetSummary {
  presetId: string
  name: string
  kind: PresetKind
  createdAt: string
  updatedAt: string
  legs: PresetLeg[]
}

/**
 * One leg of a preset, projected so the account picker can decide whether a
 * preset is runnable without fetching the payload.
 */
export interface PresetLeg {
  /**
   * Absent where the command names no single instrument (an RFQ accept or
   * cancel, an unscoped cancel-all).
   */
  instrument?: string | undefined
  /**
   * UNSPECIFIED where the leg names no side (a cancel, a cross-exchange arb
   * leg).
   */
  side: OrderSide
  /**
   * Resolved from the caller's account link, never from the stored payload —
   * the payload's own venue fields are client-supplied and untrusted.
   * UNSPECIFIED when account_id names no account the caller can read, and also
   * when the account lookup itself could not be completed.
   */
  tradeVenue: TradeVenue
  accountId: string
}

export interface CreatePresetRequest {
  name: string
  payload: PresetPayload | undefined
}

export interface CreatePresetResponse {
  preset: Preset | undefined
}

export interface UpdatePresetRequest {
  presetId: string
  /** rename */
  name?: string | undefined
  /** full replace */
  payload?: PresetPayload | undefined
}

export interface UpdatePresetResponse {
  preset: Preset | undefined
}

export interface DeletePresetRequest {
  presetId: string
}

export interface DeletePresetResponse {}

export interface GetPresetRequest {
  presetId: string
}

export interface GetPresetResponse {
  preset: Preset | undefined
}

export interface ListPresetsRequest {}

export interface ListPresetsResponse {
  presets: PresetSummary[]
}

export interface ExecutePresetRequest {
  presetId: string
  /**
   * Absent: run each leg against the account stored in the payload. Present:
   * override every leg with this account, as every caller did before the
   * stored accounts were honoured.
   */
  accountId?: string | undefined
}

export interface ExecutePresetResponse {
  orderIds: string[]
  algoIds: string[]
}

function createBasePresetPayload(): PresetPayload {
  return { commands: undefined, algoCommands: undefined }
}

export const PresetPayload: MessageFns<PresetPayload> = {
  encode(message: PresetPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commands !== undefined) {
      OrderExecutionCommandList.encode(message.commands, writer.uint32(10).fork()).join()
    }
    if (message.algoCommands !== undefined) {
      AlgoServiceCommandList.encode(message.algoCommands, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PresetPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePresetPayload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.commands = OrderExecutionCommandList.decode(reader, reader.uint32())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoCommands = AlgoServiceCommandList.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PresetPayload {
    return {
      commands: isSet(object.commands)
        ? OrderExecutionCommandList.fromJSON(object.commands)
        : undefined,
      algoCommands: isSet(object.algoCommands)
        ? AlgoServiceCommandList.fromJSON(object.algoCommands)
        : isSet(object.algo_commands)
          ? AlgoServiceCommandList.fromJSON(object.algo_commands)
          : undefined,
    }
  },

  toJSON(message: PresetPayload): unknown {
    const obj: any = {}
    if (message.commands !== undefined) {
      obj.commands = OrderExecutionCommandList.toJSON(message.commands)
    }
    if (message.algoCommands !== undefined) {
      obj.algoCommands = AlgoServiceCommandList.toJSON(message.algoCommands)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PresetPayload>, I>>(base?: I): PresetPayload {
    return PresetPayload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PresetPayload>, I>>(object: I): PresetPayload {
    const message = createBasePresetPayload()
    message.commands =
      object.commands !== undefined && object.commands !== null
        ? OrderExecutionCommandList.fromPartial(object.commands)
        : undefined
    message.algoCommands =
      object.algoCommands !== undefined && object.algoCommands !== null
        ? AlgoServiceCommandList.fromPartial(object.algoCommands)
        : undefined
    return message
  },
}

function createBasePreset(): Preset {
  return {
    presetId: '',
    name: '',
    kind: 0,
    createdAt: '0',
    updatedAt: '0',
    deleted: false,
    payload: undefined,
  }
}

export const Preset: MessageFns<Preset> = {
  encode(message: Preset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(40).int64(message.updatedAt)
    }
    if (message.deleted !== false) {
      writer.uint32(48).bool(message.deleted)
    }
    if (message.payload !== undefined) {
      PresetPayload.encode(message.payload, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Preset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePreset()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.deleted = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.payload = PresetPayload.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Preset {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      kind: isSet(object.kind) ? presetKindFromJSON(object.kind) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      deleted: isSet(object.deleted) ? globalThis.Boolean(object.deleted) : false,
      payload: isSet(object.payload) ? PresetPayload.fromJSON(object.payload) : undefined,
    }
  },

  toJSON(message: Preset): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.kind !== 0) {
      obj.kind = presetKindToJSON(message.kind)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.deleted !== false) {
      obj.deleted = message.deleted
    }
    if (message.payload !== undefined) {
      obj.payload = PresetPayload.toJSON(message.payload)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Preset>, I>>(base?: I): Preset {
    return Preset.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Preset>, I>>(object: I): Preset {
    const message = createBasePreset()
    message.presetId = object.presetId ?? ''
    message.name = object.name ?? ''
    message.kind = object.kind ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.deleted = object.deleted ?? false
    message.payload =
      object.payload !== undefined && object.payload !== null
        ? PresetPayload.fromPartial(object.payload)
        : undefined
    return message
  },
}

function createBasePresetSummary(): PresetSummary {
  return { presetId: '', name: '', kind: 0, createdAt: '0', updatedAt: '0', legs: [] }
}

export const PresetSummary: MessageFns<PresetSummary> = {
  encode(message: PresetSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(40).int64(message.updatedAt)
    }
    for (const v of message.legs) {
      PresetLeg.encode(v!, writer.uint32(50).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PresetSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePresetSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.kind = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.legs.push(PresetLeg.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PresetSummary {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      kind: isSet(object.kind) ? presetKindFromJSON(object.kind) : 0,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      legs: globalThis.Array.isArray(object?.legs)
        ? object.legs.map((e: any) => PresetLeg.fromJSON(e))
        : [],
    }
  },

  toJSON(message: PresetSummary): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.kind !== 0) {
      obj.kind = presetKindToJSON(message.kind)
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.legs?.length) {
      obj.legs = message.legs.map((e) => PresetLeg.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PresetSummary>, I>>(base?: I): PresetSummary {
    return PresetSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PresetSummary>, I>>(object: I): PresetSummary {
    const message = createBasePresetSummary()
    message.presetId = object.presetId ?? ''
    message.name = object.name ?? ''
    message.kind = object.kind ?? 0
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.legs = object.legs?.map((e) => PresetLeg.fromPartial(e)) || []
    return message
  },
}

function createBasePresetLeg(): PresetLeg {
  return { instrument: undefined, side: 0, tradeVenue: 0, accountId: '' }
}

export const PresetLeg: MessageFns<PresetLeg> = {
  encode(message: PresetLeg, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.instrument !== undefined) {
      writer.uint32(10).string(message.instrument)
    }
    if (message.side !== 0) {
      writer.uint32(16).int32(message.side)
    }
    if (message.tradeVenue !== 0) {
      writer.uint32(24).int32(message.tradeVenue)
    }
    if (message.accountId !== '') {
      writer.uint32(34).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PresetLeg {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePresetLeg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.instrument = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.side = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.tradeVenue = reader.int32() as any
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PresetLeg {
    return {
      instrument: isSet(object.instrument) ? globalThis.String(object.instrument) : undefined,
      side: isSet(object.side) ? orderSideFromJSON(object.side) : 0,
      tradeVenue: isSet(object.tradeVenue)
        ? tradeVenueFromJSON(object.tradeVenue)
        : isSet(object.trade_venue)
          ? tradeVenueFromJSON(object.trade_venue)
          : 0,
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
    }
  },

  toJSON(message: PresetLeg): unknown {
    const obj: any = {}
    if (message.instrument !== undefined) {
      obj.instrument = message.instrument
    }
    if (message.side !== 0) {
      obj.side = orderSideToJSON(message.side)
    }
    if (message.tradeVenue !== 0) {
      obj.tradeVenue = tradeVenueToJSON(message.tradeVenue)
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PresetLeg>, I>>(base?: I): PresetLeg {
    return PresetLeg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PresetLeg>, I>>(object: I): PresetLeg {
    const message = createBasePresetLeg()
    message.instrument = object.instrument ?? undefined
    message.side = object.side ?? 0
    message.tradeVenue = object.tradeVenue ?? 0
    message.accountId = object.accountId ?? ''
    return message
  },
}

function createBaseCreatePresetRequest(): CreatePresetRequest {
  return { name: '', payload: undefined }
}

export const CreatePresetRequest: MessageFns<CreatePresetRequest> = {
  encode(message: CreatePresetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== '') {
      writer.uint32(10).string(message.name)
    }
    if (message.payload !== undefined) {
      PresetPayload.encode(message.payload, writer.uint32(18).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePresetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreatePresetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.payload = PresetPayload.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreatePresetRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      payload: isSet(object.payload) ? PresetPayload.fromJSON(object.payload) : undefined,
    }
  },

  toJSON(message: CreatePresetRequest): unknown {
    const obj: any = {}
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.payload !== undefined) {
      obj.payload = PresetPayload.toJSON(message.payload)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreatePresetRequest>, I>>(base?: I): CreatePresetRequest {
    return CreatePresetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreatePresetRequest>, I>>(
    object: I
  ): CreatePresetRequest {
    const message = createBaseCreatePresetRequest()
    message.name = object.name ?? ''
    message.payload =
      object.payload !== undefined && object.payload !== null
        ? PresetPayload.fromPartial(object.payload)
        : undefined
    return message
  },
}

function createBaseCreatePresetResponse(): CreatePresetResponse {
  return { preset: undefined }
}

export const CreatePresetResponse: MessageFns<CreatePresetResponse> = {
  encode(message: CreatePresetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preset !== undefined) {
      Preset.encode(message.preset, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePresetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCreatePresetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.preset = Preset.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CreatePresetResponse {
    return { preset: isSet(object.preset) ? Preset.fromJSON(object.preset) : undefined }
  },

  toJSON(message: CreatePresetResponse): unknown {
    const obj: any = {}
    if (message.preset !== undefined) {
      obj.preset = Preset.toJSON(message.preset)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CreatePresetResponse>, I>>(base?: I): CreatePresetResponse {
    return CreatePresetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CreatePresetResponse>, I>>(
    object: I
  ): CreatePresetResponse {
    const message = createBaseCreatePresetResponse()
    message.preset =
      object.preset !== undefined && object.preset !== null
        ? Preset.fromPartial(object.preset)
        : undefined
    return message
  },
}

function createBaseUpdatePresetRequest(): UpdatePresetRequest {
  return { presetId: '', name: undefined, payload: undefined }
}

export const UpdatePresetRequest: MessageFns<UpdatePresetRequest> = {
  encode(message: UpdatePresetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name)
    }
    if (message.payload !== undefined) {
      PresetPayload.encode(message.payload, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePresetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdatePresetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.payload = PresetPayload.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdatePresetRequest {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      payload: isSet(object.payload) ? PresetPayload.fromJSON(object.payload) : undefined,
    }
  },

  toJSON(message: UpdatePresetRequest): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    if (message.name !== undefined) {
      obj.name = message.name
    }
    if (message.payload !== undefined) {
      obj.payload = PresetPayload.toJSON(message.payload)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdatePresetRequest>, I>>(base?: I): UpdatePresetRequest {
    return UpdatePresetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePresetRequest>, I>>(
    object: I
  ): UpdatePresetRequest {
    const message = createBaseUpdatePresetRequest()
    message.presetId = object.presetId ?? ''
    message.name = object.name ?? undefined
    message.payload =
      object.payload !== undefined && object.payload !== null
        ? PresetPayload.fromPartial(object.payload)
        : undefined
    return message
  },
}

function createBaseUpdatePresetResponse(): UpdatePresetResponse {
  return { preset: undefined }
}

export const UpdatePresetResponse: MessageFns<UpdatePresetResponse> = {
  encode(message: UpdatePresetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preset !== undefined) {
      Preset.encode(message.preset, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePresetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUpdatePresetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.preset = Preset.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UpdatePresetResponse {
    return { preset: isSet(object.preset) ? Preset.fromJSON(object.preset) : undefined }
  },

  toJSON(message: UpdatePresetResponse): unknown {
    const obj: any = {}
    if (message.preset !== undefined) {
      obj.preset = Preset.toJSON(message.preset)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UpdatePresetResponse>, I>>(base?: I): UpdatePresetResponse {
    return UpdatePresetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePresetResponse>, I>>(
    object: I
  ): UpdatePresetResponse {
    const message = createBaseUpdatePresetResponse()
    message.preset =
      object.preset !== undefined && object.preset !== null
        ? Preset.fromPartial(object.preset)
        : undefined
    return message
  },
}

function createBaseDeletePresetRequest(): DeletePresetRequest {
  return { presetId: '' }
}

export const DeletePresetRequest: MessageFns<DeletePresetRequest> = {
  encode(message: DeletePresetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePresetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePresetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeletePresetRequest {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
    }
  },

  toJSON(message: DeletePresetRequest): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePresetRequest>, I>>(base?: I): DeletePresetRequest {
    return DeletePresetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePresetRequest>, I>>(
    object: I
  ): DeletePresetRequest {
    const message = createBaseDeletePresetRequest()
    message.presetId = object.presetId ?? ''
    return message
  },
}

function createBaseDeletePresetResponse(): DeletePresetResponse {
  return {}
}

export const DeletePresetResponse: MessageFns<DeletePresetResponse> = {
  encode(_: DeletePresetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePresetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePresetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): DeletePresetResponse {
    return {}
  },

  toJSON(_: DeletePresetResponse): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePresetResponse>, I>>(base?: I): DeletePresetResponse {
    return DeletePresetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePresetResponse>, I>>(_: I): DeletePresetResponse {
    const message = createBaseDeletePresetResponse()
    return message
  },
}

function createBaseGetPresetRequest(): GetPresetRequest {
  return { presetId: '' }
}

export const GetPresetRequest: MessageFns<GetPresetRequest> = {
  encode(message: GetPresetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPresetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPresetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPresetRequest {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
    }
  },

  toJSON(message: GetPresetRequest): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPresetRequest>, I>>(base?: I): GetPresetRequest {
    return GetPresetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPresetRequest>, I>>(object: I): GetPresetRequest {
    const message = createBaseGetPresetRequest()
    message.presetId = object.presetId ?? ''
    return message
  },
}

function createBaseGetPresetResponse(): GetPresetResponse {
  return { preset: undefined }
}

export const GetPresetResponse: MessageFns<GetPresetResponse> = {
  encode(message: GetPresetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preset !== undefined) {
      Preset.encode(message.preset, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPresetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetPresetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.preset = Preset.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetPresetResponse {
    return { preset: isSet(object.preset) ? Preset.fromJSON(object.preset) : undefined }
  },

  toJSON(message: GetPresetResponse): unknown {
    const obj: any = {}
    if (message.preset !== undefined) {
      obj.preset = Preset.toJSON(message.preset)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetPresetResponse>, I>>(base?: I): GetPresetResponse {
    return GetPresetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetPresetResponse>, I>>(object: I): GetPresetResponse {
    const message = createBaseGetPresetResponse()
    message.preset =
      object.preset !== undefined && object.preset !== null
        ? Preset.fromPartial(object.preset)
        : undefined
    return message
  },
}

function createBaseListPresetsRequest(): ListPresetsRequest {
  return {}
}

export const ListPresetsRequest: MessageFns<ListPresetsRequest> = {
  encode(_: ListPresetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPresetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListPresetsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ListPresetsRequest {
    return {}
  },

  toJSON(_: ListPresetsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ListPresetsRequest>, I>>(base?: I): ListPresetsRequest {
    return ListPresetsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListPresetsRequest>, I>>(_: I): ListPresetsRequest {
    const message = createBaseListPresetsRequest()
    return message
  },
}

function createBaseListPresetsResponse(): ListPresetsResponse {
  return { presets: [] }
}

export const ListPresetsResponse: MessageFns<ListPresetsResponse> = {
  encode(message: ListPresetsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.presets) {
      PresetSummary.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPresetsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListPresetsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presets.push(PresetSummary.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListPresetsResponse {
    return {
      presets: globalThis.Array.isArray(object?.presets)
        ? object.presets.map((e: any) => PresetSummary.fromJSON(e))
        : [],
    }
  },

  toJSON(message: ListPresetsResponse): unknown {
    const obj: any = {}
    if (message.presets?.length) {
      obj.presets = message.presets.map((e) => PresetSummary.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListPresetsResponse>, I>>(base?: I): ListPresetsResponse {
    return ListPresetsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListPresetsResponse>, I>>(
    object: I
  ): ListPresetsResponse {
    const message = createBaseListPresetsResponse()
    message.presets = object.presets?.map((e) => PresetSummary.fromPartial(e)) || []
    return message
  },
}

function createBaseExecutePresetRequest(): ExecutePresetRequest {
  return { presetId: '', accountId: undefined }
}

export const ExecutePresetRequest: MessageFns<ExecutePresetRequest> = {
  encode(message: ExecutePresetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.presetId !== '') {
      writer.uint32(10).string(message.presetId)
    }
    if (message.accountId !== undefined) {
      writer.uint32(18).string(message.accountId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutePresetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutePresetRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.presetId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutePresetRequest {
    return {
      presetId: isSet(object.presetId)
        ? globalThis.String(object.presetId)
        : isSet(object.preset_id)
          ? globalThis.String(object.preset_id)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : undefined,
    }
  },

  toJSON(message: ExecutePresetRequest): unknown {
    const obj: any = {}
    if (message.presetId !== '') {
      obj.presetId = message.presetId
    }
    if (message.accountId !== undefined) {
      obj.accountId = message.accountId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutePresetRequest>, I>>(base?: I): ExecutePresetRequest {
    return ExecutePresetRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutePresetRequest>, I>>(
    object: I
  ): ExecutePresetRequest {
    const message = createBaseExecutePresetRequest()
    message.presetId = object.presetId ?? ''
    message.accountId = object.accountId ?? undefined
    return message
  },
}

function createBaseExecutePresetResponse(): ExecutePresetResponse {
  return { orderIds: [], algoIds: [] }
}

export const ExecutePresetResponse: MessageFns<ExecutePresetResponse> = {
  encode(message: ExecutePresetResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.orderIds) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.algoIds) {
      writer.uint32(18).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecutePresetResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExecutePresetResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.orderIds.push(reader.string())
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.algoIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExecutePresetResponse {
    return {
      orderIds: globalThis.Array.isArray(object?.orderIds)
        ? object.orderIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.order_ids)
          ? object.order_ids.map((e: any) => globalThis.String(e))
          : [],
      algoIds: globalThis.Array.isArray(object?.algoIds)
        ? object.algoIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.algo_ids)
          ? object.algo_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: ExecutePresetResponse): unknown {
    const obj: any = {}
    if (message.orderIds?.length) {
      obj.orderIds = message.orderIds
    }
    if (message.algoIds?.length) {
      obj.algoIds = message.algoIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExecutePresetResponse>, I>>(base?: I): ExecutePresetResponse {
    return ExecutePresetResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExecutePresetResponse>, I>>(
    object: I
  ): ExecutePresetResponse {
    const message = createBaseExecutePresetResponse()
    message.orderIds = object.orderIds?.map((e) => e) || []
    message.algoIds = object.algoIds?.map((e) => e) || []
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
